import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// GSAP Animations

let mm = gsap.matchMedia();

// anims only run on certain viewport sizes
mm.add("(min-width: 992px)", () => {
    gsap.from("#form-background img", {
        scrollTrigger: {
            trigger: "#form-background",
            start: "bottom bottom", // start anim when bottom of trigger element hits bottom of viewport
        },
        yPercent: 100,
        ease: "power2",
        rotation: gsap.utils.wrap([-25, 25]),
        duration: 0.6,
        stagger: 0.1
    });
});

mm.add("(min-width: 768px)", () => {
    gsap.from("#contact-images-container a", {
        scrollTrigger: {
            trigger: "#contact-images-container",
            start: "top 80%", // start anim when top of trigger element hits 80% of viewport height
        },
        ease: "power3.out",
        x: gsap.utils.wrap([20, -20]),
        duration: 0.5,
        stagger: 0.08
    });
});